<script setup lang="ts">
import type { LineItem } from '~/types/shopware'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  cartItems: LineItem[]
}>()
</script>
<template>
  <div class="cart-table f-18">
    <div class="cart-table-header">
      <div class="label f-bold">{{ t('shop.cartPage.productsTable.product') }}</div>
      <div class="label f-bold">{{ t('shop.cartPage.productsTable.number') }}</div>
      <div class="label f-bold">{{ t('shop.cartPage.productsTable.includingVAT') }}</div>
      <div class="label f-bold">{{ t('shop.cartPage.productsTable.total') }}</div>
      <div />
    </div>
    <div v-for="cartItem in cartItems" :key="cartItem.id" class="cart-table-element">
      <ShopCartItem :cart-item="cartItem" />
    </div>
  </div>
</template>
<style scoped lang="scss">
.cart-table {
  margin-bottom: var(--p-mb);
  &-header,
  &-element {
    display: grid;
    gap: 32px;
    align-items: center;
    border-bottom: 1px solid var(--c-line-light);
    grid-template-columns: 1fr 1fr;

    @include breakpoint(ts) {
      grid-template-columns: minmax(0, 3fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) 20px;
    }
    & > div,
    & > :deep(div) {
      &:first-child {
        grid-column: 1 / 3;
        @include breakpoint(ts) {
          grid-column: 1;
        }
      }
      &:last-child {
        text-align: right;
      }
      @include breakpoint(ts) {
        text-align: right;
        &:first-child {
          text-align: left;
        }
      }
    }
  }
  &-header {
    color: var(--c-primary);
    display: none;
    padding: 24px 0;
    @include breakpoint(ts) {
      display: grid;
    }
  }
  &-element {
    padding: 21px 0;
  }
}
</style>
